import type { EngineId, WorldRenderer } from './core/types';

export async function createRenderer(engine: EngineId): Promise<WorldRenderer> {
  switch (engine) {
    case 'cesium': {
      const { CesiumRenderer } = await import('./engines/cesium/CesiumRenderer');
      return new CesiumRenderer();
    }
    case 'maplibre': {
      const { MapLibreRenderer } = await import('./engines/maplibre/MapLibreRenderer');
      return new MapLibreRenderer();
    }
    case 'native': {
      const { NativeGlobeRenderer } = await import('./engines/native/NativeGlobeRenderer');
      return new NativeGlobeRenderer();
    }
    default:
      throw new Error(`Unknown renderer engine: ${String(engine)}`);
  }
}
